import React from "react";
import Home from "./Home";
const HomeContainer = () => {
    return (
        <>
            <Home />
        </>
    );
};

export default HomeContainer;
